/* global React */
import { useEffect, useRef, useState } from 'react'
import { Grid, Skeleton } from '@mui/material'

/**
 * Simple Template Placeholder
 *
 * Displays a (one) simple {@link Skeleton} box as a placeholder.
 *
 * @param {Object} [props]                                  element's properties
 * @param {React.ReactNode[]} [props.children]              children to wrap the skeleton around.
 *                                                          Useful because the skeleton will infer
 *                                                          its height based on children
 * @param {boolean} [props.hidden=true]                     whether the element should be hidden
 * @param {number} [props.timeout]                          timeout until the placeholder is shown
 * @param {Object} [props.placeholderProps]                 placeholder's properties
 * @param {number|string} [props.placeholderProps.height]   height of the placeholder
 * @param {number|string} [props.placeholderProps.width]    width of the placeholder
 * @param {number|string} [props.placeholderProps.variant]  variant of the placeholder
 */
const PlaceholderSimple = ({ children = [], placeholderProps, ...props }) => {
  const { hidden = true, timeout = 2000 } = props
  const { height = 20, width = '100%', variant = 'rounded' } = placeholderProps || {}
  const [isHidden, setIsHidden] = useState(hidden)
  const timer = useRef(setTimeout(() => setIsHidden(false), timeout))

  useEffect(() => () => clearTimeout(timer.current), [])

  return isHidden ? null : (
    <Grid
      item
      container
      height={'100%'}
      alignItems={'center'}
      justifyContent={'space-around'}
    >
      <Skeleton
        variant={variant}
        width={width}
        style={{ backgroundColor: 'rgba(87, 87, 87, 0.11)' }}
        {...children.length === 0 && { height }}
      >
        {children}
      </Skeleton>
    </Grid>
  )
}

export default PlaceholderSimple
